import React, { useCallback, useMemo } from 'react';
import Menu from 'antd/es/menu';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

import { useAppDispatch, useAppSelector } from 'utils/hooks';
import { getProfileName } from 'models/profile/selectors';
import { PathCreator, RoutePaths } from 'routing/constants';
import { BackToIcon } from 'components/icons/back-to-icon';
import { MemberIcon } from 'components/icons/profile/member-icon';
import { MyBookingIcon } from 'components/icons/profile/my-booking-icon';
import { ProfileWaitlistIcon } from 'components/icons/profile/profile-waitlist-icon';
import { ArrowDownIcon } from 'components/icons/system/arrows/arrow-down-icon';

import { Name, ProfileDropdown, SignUpButton, UnauthorizedContainer, UserNameContainer } from './elements';
import { getCourseSelector } from 'models/course/selectors';

export const getProfileMenu = (onMenuClick: ({ key }: { key: string }) => void, waitlistActive: boolean) => (
  <Menu onClick={onMenuClick}>
    <Menu.Item key={PathCreator[RoutePaths.PROFILE].getUrl()}>
      <MemberIcon /> Profile
    </Menu.Item>
    <Menu.Item key={PathCreator[RoutePaths.PROFILE_BOOKINGS].getUrl()}>
      <MyBookingIcon /> My bookings
    </Menu.Item>
    <Menu.Item key={PathCreator[RoutePaths.PROFILE_WAITLIST].getUrl()} hidden={!waitlistActive}>
      <ProfileWaitlistIcon /> Tee Time Waitlist
    </Menu.Item>
    <Menu.Item key={PathCreator[RoutePaths.AUTH_LOGOUT].getUrl()}>
      <BackToIcon /> Logout
    </Menu.Item>
  </Menu>
);

interface IProfileMenu {
  onClickCallback?: () => void;
}

export const ProfileMenu = ({ onClickCallback }: IProfileMenu) => {
  const dispatch = useAppDispatch();
  const breakpoints = useBreakpoint();
  const profileName = useSelector(getProfileName);
  const course = useAppSelector(getCourseSelector);

  const onMenuClick = useCallback(
    ({ key }) => {
      onClickCallback?.();
      dispatch(push(key));
    },
    [dispatch, onClickCallback]
  );

  const profileMenu = useMemo(() => {
    return getProfileMenu(onMenuClick, !!course?.waitlistActive);
  }, [onMenuClick, course]);

  const useMobileVersion = !breakpoints.xl;

  return (
    <>
      {Boolean(profileName) ? (
        <>
          {!useMobileVersion ? (
            <ProfileDropdown overlay={profileMenu} trigger={['click']}>
              <UserNameContainer>
                Hello, <Name>{profileName}</Name>
                <ArrowDownIcon />
              </UserNameContainer>
            </ProfileDropdown>
          ) : null}
        </>
      ) : (
        <UnauthorizedContainer>
          <Link to={PathCreator[RoutePaths.AUTH_LOGIN].getUrl()}>Log In</Link>

          <Link to={PathCreator[RoutePaths.AUTH_SIGNUP].getUrl()}>
            <SignUpButton>Sign Up</SignUpButton>
          </Link>
        </UnauthorizedContainer>
      )}
    </>
  );
};

